import { render } from "./CourseHeader.vue?vue&type=template&id=cc691ac6&scoped=true"
import script from "./CourseHeader.vue?vue&type=script&lang=js"
export * from "./CourseHeader.vue?vue&type=script&lang=js"

import "./CourseHeader.vue?vue&type=style&index=0&id=cc691ac6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc691ac6"]])

export default __exports__